/* ============================================================
   BBF Brand Story — Auto-advancing crossfade carousel
   ============================================================ */

(function () {
  function initCarousel(carousel) {
    const slides = Array.from(carousel.querySelectorAll('.bbf-brand-story__slide'));
    if (slides.length <= 1) return;

    // Read interval from data attribute (set via Liquid), default 3s
    const interval = parseInt(carousel.dataset.interval || '3', 10) * 1000;
    let current = 0;

    setInterval(function () {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, interval);
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-brand-carousel]').forEach(initCarousel);
    });
  } else {
    document.querySelectorAll('[data-brand-carousel]').forEach(initCarousel);
  }
})();
